module.exports = __webpack_public_path__ + "img/corrupted_ancient_of_annihilation_small.731d9cd4.png";